module.exports = __webpack_public_path__ + "img/smart-forfour.1dbab2c0.jpg";